export const INDUSTRIES = [
  {
    num: "01",
    name: "Startups & Entrepreneurs",
    tagline:
      "Structure the venture right, protect the brand, and sign founder-safe documents from day one.",
    helps: [
      "Choice of business structure and incorporation documentation",
      "Founder agreements, NDAs and early-stage contract templates",
      "Trademark protection for the brand as it enters the market",
    ],
  },
  {
    num: "02",
    name: "Retail & E-Commerce Businesses",
    tagline:
      "From shop licences to supplier terms — the legal layer behind a storefront, physical or online.",
    helps: [
      "Shops and establishments registration and premises compliance",
      "Vendor, supplier and marketplace terms that protect margins",
      "Consumer-facing documentation and returns/refund policies",
    ],
  },
  {
    num: "03",
    name: "Manufacturing & Industrial Businesses",
    tagline:
      "Documentation and compliance for units that carry heavy regulatory exposure.",
    helps: [
      "Factory, storage and premises-specific compliance support",
      "Vendor, procurement and works contracts",
      "Employment documentation and labour-law compliance reviews",
    ],
  },
  {
    num: "04",
    name: "Food & Beverage Businesses",
    tagline:
      "The food industry runs on registrations — we help you keep the whole licence layer current.",
    helps: [
      "Licensing and registration support for food businesses",
      "Lease documentation for kitchens, cafes and outlets",
      "Distribution, supply and franchise arrangements",
    ],
  },
  {
    num: "05",
    name: "Real Estate & Property Businesses",
    tagline:
      "Diligence, documentation and transaction support for property-heavy businesses.",
    helps: [
      "Title verification and due diligence on acquisitions and leases",
      "Lease, leave-and-license and development documentation",
      "Legal review of property records before investment or lending",
    ],
  },
  {
    num: "06",
    name: "Professional Service Providers",
    tagline:
      "Practices and consultancies that trade on expertise, confidentiality and clean paper.",
    helps: [
      "Client engagement letters and service agreements",
      "NDAs, data-handling terms and confidentiality frameworks",
      "Structuring advice for LLPs and professional entities",
    ],
  },
  {
    num: "07",
    name: "Small & Medium Enterprises",
    tagline:
      "General-counsel style support, sized for businesses that do not have an in-house team.",
    helps: [
      "A regular point of contact for day-to-day legal questions",
      "Contract reviews, notices and compliance calendars",
      "Recovery and dispute support when commercial matters turn sour",
    ],
  },
];
